import React, { useEffect, useRef, useState } from "react";
import styles from "../components/comp_css/chapter_13.module.css";
import Head from "next/head";
import MembershipModal from "../../../components/Modal/MembershipModal";
import { useRouter } from "next/router";
import { Link } from "@mui/material";
import BlockData from "../../../central-doctraine-json/chapter13.json";
import Common_html from "./Common_html";

function Chapter_13() {
  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };


  return (
    <>
      <Head>
        <title>Synchronicity | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content=" Divine Infinite Being, Central Doctrine, Chapter-XIII"
        ></meta>
        <meta
          property="og:title"
          content="Synchronicity | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Copy_of_School_of_the_Divine_Infinite_Being_Chapter13-_OG_image_Mithun_04-10-2023_v1_new.webp"
        ></meta>
         <meta property="og:image:alt" content="Illustration of interconnected cosmic elements symbolizing the concept of synchronicity in the context of a divine, infinite being."></meta>
        <meta
          property="og:description"
          content="Synchronicity refers to the life experience noncausal and unexplainable events manifested under and seem to be occurring in the same environment."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=13"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Copy_of_School_of_the_Divine_Infinite_Being_Chapter13-_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Illustration of interconnected cosmic elements symbolizing the concept of synchronicity in the context of a divine, infinite being."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=13"></meta>
        <meta name="twitter:title" content="Synchronicity | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Synchronicity refers to the life experience noncausal and unexplainable events manifested under and seem to be occurring in the same environment."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=13" />
      </Head>


       <Common_html BlockData={BlockData} />
      <MembershipModal membershipOpen={membershipOpen} setMembershipOpen={setMembershipOpen}/>
    </>
  );
}

export default Chapter_13;
